import req from './request'

const DEFAULT_ENDPOINTS = {
    phone: '/telephony/phone',
    rules: '/telephony/rules',
    reference: '/telephony/reference'
}

export default {
    phone(payload, param, method)  {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.phone, param)
    },
    rules(payload, param, method)  {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.rules, param)
    },
    reference(payload, param, method)  {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.reference, param)
    },
}